import React from "react";
import ReactDOM from "react-dom/client";
import "@/lib/domGuard";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { ErrorBoundary } from "@/components/ErrorBoundary";

// Silenzia il falso positivo "ResizeObserver loop" che in dev attiva l'overlay CRA
// bloccando i click (es. editor Landing con iframe + pannello che si ridimensionano).
const _roMsg = "ResizeObserver loop";
window.addEventListener("error", (e) => {
  if (e?.message && e.message.includes(_roMsg)) { e.stopImmediatePropagation(); e.preventDefault(); }
}, true);
window.addEventListener("unhandledrejection", (e) => {
  const m = e?.reason?.message || "";
  if (typeof m === "string" && m.includes(_roMsg)) e.preventDefault();
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
